import React, { useEffect } from "react";
import AOS from "aos";

const AnimatedText = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <div style={{ overflow: "hidden", textAlign: "center" }}>
      {" "}
      <h6 className="about-text">
        <div data-aos="fade-right" style={{ display: "inline-block" }}>
          <span style={{ color: "#F1E4E4BF" }}>Nice to meet you! I turn</span>
        </div>{" "}
        <div
          className="text-highlight"
          data-aos="zoom-in"
          data-aos-delay="300"
          style={{ display: "inline-block" }}
        >
          human behavior
        </div>{" "}
        <div data-aos="fade-left" style={{ display: "inline-block" }}>
          <span style={{ color: "#F1E4E4BF" }}> into </span>
        </div>{" "}
        <div data-aos="fade-left" style={{ display: "inline-block" }}>
          <span className="text-highlight"> intuitive design.</span>
        </div>
      </h6>
    </div>
  );
};

export default AnimatedText;
